import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

//style
import '../../assets/css/errors.css'

//images
import notFound from '../../assets/images/errors/404.png';

function NotFound(props) {

    return (
        <>
            <div className="basic basic-special"></div>

            <main id="errors">
                <div className="wrapper">
                    <img src={notFound} alt="error" />
                    <h1>
                        Страницата не е намерена!
                </h1>
                    <p>
                        Не беше намерен резултат от Вашето търсене.
                </p>
                    <Button>
                        <Link to="/">
                            Начало
                        </Link>
                    </Button>
                </div>
            </main>
        </>
    )
}

export default NotFound;